<template>
  <v-app>
    <azure-storage
      :id="azureStorageClientId"
      prefix="client"
      :value="fileUploaderOpen"
      @input="fileUploaderOpen = $event"
    />
    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.mdAndUp"
      v-model="drawer"
      fixed
      app
      width="230"
    >
      <navigation />
    </v-navigation-drawer>
    <v-toolbar
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      color="#1e355e"
      dark
      app
      fixed
      height="45px"
    >
      <v-toolbar-title class="ml-0 pl-3">
        <v-toolbar-side-icon
          @click.stop="drawer = !drawer"
          title="Show Menu Bar"
        ></v-toolbar-side-icon>
        <breadcrumbs />
        <v-btn
          title="Client's Documents"
          color="#1e355e"
          small
          fab
          v-if="!isMaster"
          @click="azureStorageOpenClick"
        >
          <i class="fas fa-paperclip fa-mc azureStorageOpen"></i>
        </v-btn>
        <client-selector class="hidden-sm-and-down" />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <img
        src="/api/config/Client/getLogo?clientId=0"
        height="24px"
        class="hidden-sm-and-down"
        v-show="currentPath != '/' && isLoggedIn"
      />
      <label id="inactiveTime" hidden>{{ time }}</label>
      <quick-navigation v-if="isLoggedIn" />
      <v-toolbar-items>
        <v-btn v-if="!isLoggedIn" to="/login" flat>Login</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <environment />
    <v-content>
      <v-container fluid>
        <slot> Content will be here </slot>
      </v-container>
    </v-content>
    <version-info
      :version-modal-visible="versionModalVisible"
      @close="toggleVersionModal"
    ></version-info>
    <v-footer color="black" dark app>
      <span style="padding-left:14px">
        <span>Star </span>
        <span v-if="isLoggedIn" class="hidden-sm-and-down"> - Version: </span>
        <span v-if="isLoggedIn" class="appVersion" @click="toggleVersionModal">{{
          applicationVersion
        }}</span>
        <span> &copy; {{ new Date().getFullYear() }} - </span>
        <span class="hidden-sm-and-down">Powered by </span>
        <a target="blank" href="https://www.visionap.com"> VisionAp</a>
      </span>
      <span>
        <fx-rate-monitor />
      </span>
      <v-spacer></v-spacer>
      <own-user-settings v-model="showSettingsModal" />
      <v-btn
        v-if="isLoggedIn"
        flat
        v-text="roleUser"
        class="hidden-xs-only"
        @click="showSettingsModal = true"
      ></v-btn>
      <v-btn v-if="isLoggedIn" @click="logout" flat>Logout</v-btn>
    </v-footer>
    <div ref="preloader" id="preloader">
      <img src="../assets/logo.png" alt="STAR" />
    </div>

    <v-dialog v-model="logoutVisible" persistent max-width="382px">
      <v-card class="mx-auto">
        <v-toolbar dark color="primary" height="45">
          <v-toolbar-title>Session Timeout</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>Logout in: {{ logoutTime }} seconds.</v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="close">Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
const $ = kendo.jQuery
import Vue from 'vue'
import {mapGetters} from 'vuex'
import Navigation from './Navigation'
import AzureStorage from '@/components/AzureStorage'
import ClientSelector from './ClientSelector'
import Breadcrumbs from './Breadcrumbs'
import VersionInfo from './VersionInfo'
import Environment from './Environment'
import QuickNavigation from './QuickNavigation'
import OwnUserSettings from './UserManager/OwnUserSettings'
import FxRateMonitor from '@/components/FxRateMonitor'

export default {
  components: {
    Navigation,
    ClientSelector,
    Breadcrumbs,
    VersionInfo,
    Environment,
    QuickNavigation,
    OwnUserSettings,
    AzureStorage,
    FxRateMonitor,
  },
  async mounted() {
    await this.resetInterval()
    await this.verifyActivity()
    window.setTimeout(function() {
      $('#preloader').hide('fadeIn')
    }, 4820)
  },
  data() {
    return {
      azureStorageClientId: 0,
      fileUploaderOpen: false,
      sessionTime: 120 * 60 * 1000,
      activityTimers: ['click', 'mousemove', 'scroll', 'keypress', 'load'],
      drawer: false,
      versionModalVisible: false,
      showSettingsModal: false,
      warningInterval: null,
      logoutInterval: null,
      logoutTime: 14,
      logoutVisible: false,
      time: '0:00:00',
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'authentication/isLoggedIn',
      currentUsername: 'authentication/currentUsername',
      currentRole: 'authentication/currentRole',
      applicationName: 'app/applicationName',
      applicationVersion: 'app/applicationVersion',
      selectedClientId: 'authentication/selectedClientId',
    }),
    roleUser: function() {
      return this.currentUsername + '(' + this.currentRole + ')'
    },
    isMaster: function() {
      return this.selectedClientId == 0
    },
    currentPath() {
      return this.$route.path
    },
  },
  methods: {
    azureStorageOpenClick() {
      this.azureStorageClientId = this.selectedClientId
      Vue.nextTick(() => {
        this.fileUploaderOpen = true
      })
    },
    async logout() {
      await this.clearAllInterval()
      this.logoutVisible = false
      await this.$store.dispatch('authentication/logout')

      if (location.href.includes('login')) return

      await this.$router.push('/login')
    },
    toggleVersionModal() {
      this.versionModalVisible = !this.versionModalVisible
    },
    async verifyActivity() {
      const lastActivity = +window.localStorage.getItem('lastActivity')
      const logout = (Date.now() - lastActivity - this.sessionTime) / 60 / 1000 > 14
      const timeOut = lastActivity + this.sessionTime < Date.now()
      if (logout || !lastActivity) {
        this.logout()
        return
      } else if (timeOut) {
        this.warning()
        return
      }

      const activityTime = Date.now() - lastActivity
      this.time = new Date(activityTime).toISOString().substr(11, 8)
    },
    resetTimer() {
      const lastActivity = +window.localStorage.getItem('lastActivity')
      if (!lastActivity) {
        return
      }

      window.localStorage.setItem('lastActivity', Date.now())
      this.time = '00:00:00'
    },
    warning() {
      this.logoutVisible = true
      this.logoutTime = 14
      const that = this
      this.warningInterval = window.setInterval(function() {
        that.logoutTime = that.logoutTime - 1
        if (that.logoutTime <= 0) {
          that.logout()
        }
      }, 1000)
    },
    async close() {
      window.localStorage.setItem('lastActivity', Date.now())
      await this.clearAllInterval()
      this.time = '00:00:00'
      this.logoutTime = 14
      this.logoutVisible = false
    },
    async resetInterval() {
      await this.clearAllInterval()
      if (this.logoutInterval == null)
        this.logoutInterval = window.setInterval(this.verifyActivity, 1820)

      this.activityTimers.forEach(event => window.addEventListener(event, this.resetTimer))
    },
    async clearAllInterval() {
      for (var i = 0; i <= this.warningInterval; i++) {
        if (this.logoutInterval != i) await window.clearInterval(i)
      }
    },
  },
}
</script>
